import { loginLink, protectedRouteList, unauthorizedLink } from './routerLink';

import { Navigate } from 'react-router-dom';
import { ROUTE_PERMISSIONS } from '../core/constants';
import React from 'react';
import { hasAccess } from 'src/core/PermissionHandler';

export const ProtectedRoute = (props) => {
  const isAuthenticated = sessionStorage.getItem("IsAuthenticated")
  const { children, path, requestedPath } = props;
  if(isAuthenticated){
  const routePermissions = ROUTE_PERMISSIONS[path];
  
  const hasPermission = hasAccess(routePermissions);
    return (
      <>
        {hasPermission ? children : <Navigate to={unauthorizedLink} replace />}
      </>
    );
  }
   protectedRouteList.includes(requestedPath) && sessionStorage.setItem("requestedPath",requestedPath);
  
  return <Navigate to={loginLink} />
  
};